const ShippingMethod = (props) => {
  const { order } = props;
  if (order.orderDeliveryMethod === 'Pickup') {
    return (
      <span>
        <strong>Shipping method</strong>
        <br />
        Pickup
      </span>
    );
  }
  if (order.shipping && order.shipping.length >= 1) {
    return (
      <span>
        <strong>Shipping method</strong>
        <br />
        {order.shipping[0].title}
      </span>
    );
  }
  return null;
};

export default ShippingMethod;
